import * as Yup from 'yup';
import { passwordRegex } from '../constants';

export const loginYopValidation = () => {
  return Yup.object().shape({
    username: Yup.string().required('required').email('incorrectEmail'),
    password: Yup.string().required('required'),
  });
};

export const forgotPasswordYopValidation = () => {
  return Yup.object().shape({
    username: Yup.string().required('required').email('incorrectEmail'),
  });
};

export const otpYopValidation = () => {
  return Yup.object().shape({
    otp: Yup.string().required('required'),
  });
};

export const changePasswordYopValidation = () => {
  return Yup.object().shape({
    newPassword: Yup.string().required('required').min(15, 'min15').matches(passwordRegex, 'passwordPattern'),
    repeatPassword: Yup.string()
      .required('required')
      .oneOf([Yup.ref('newPassword')], 'passwordNotMatch'),
  });
};
